<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormUserSignature
      :FormUserSignature="editFormUserSignature"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormUserSignature from '../components/FormUserSignature.vue';

export default {
  components: {
    FormUserSignature,
  },
  name: 'EditUserSignature',
  module: 'Processing',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing FormSignature. Default to {}.
      */
      editFormUserSignature: {},
      /**
       * Query Id for FormSignature
       */
      userSignatureId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('userManagement', ['users']),
    ...mapState('userSignatures', ['userSignatures', 'userSignature']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.userSignatureId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_userSignatures(this.userSignatureId);
      this.editFormSignature = this.userSignature;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('userSignatures', ['LOAD_userSignatures', 'CREATE_userSignature', 'UPDATE_userSignature']),
    ...mapActions('userManagement', ['loadUsers']),
    /** Method used to save the item
     */
    async save(userSignature) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_userSignature(userSignature);
      } else {
        await this.UPDATE_userSignature(userSignature);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListUserSignature' });
    },
  },
};
</script>

<docs>
# EditFormSignature example

'''js
<EditFormSignature :FormSignature="FormSignature" />
'''
</docs>
